import React, { useEffect } from 'react'
import { useAppDispatch } from '../../../hooks/useAppDispatch'
import { useAppSelector } from '../../../hooks/useAppSelector'
import {
    selectProductBackupSettings,
    selectSettingsState,
} from '../../../store/selectors/settingsSelectors'
import { fetchProductBackupSettings } from '../../../store/async-thunks/settings/fetchProductBackupSettings'
import { BackupSettingsFields } from './BackupSettingsFields'
import Loader from '../../Loader/Loader'
import { FormattedMessage } from 'react-intl'

interface Props {
    guid: string
}

export const BackupSettings = ({ guid }: Props) => {
    const dispatch = useAppDispatch()
    const { isBackupLoading: loading, backupError: err } =
        useAppSelector(selectSettingsState)
    const backupSettings = useAppSelector(selectProductBackupSettings(guid))

    useEffect(() => {
        if (!backupSettings) {
            dispatch(fetchProductBackupSettings({ guid }))
        }
    }, [guid, dispatch]) // eslint-disable-line

    if (loading)
        return (
            <div className="vh-full d-flex justify-content-center">
                <Loader />
            </div>
        )

    if (err)
        return (
            <div className={`my-4 px-4 py-3 fs-5 error-in-frame`}>
                <FormattedMessage id={err} />
            </div>
        )

    return (
        <BackupSettingsFields
            guid={guid}
            backupSettings={backupSettings}
        />
    )
}
